import dynamic from 'next/dynamic';

export default dynamic(() => import('./StaticTimePickerInternal'), { ssr: false });
